export default __webpack_public_path__ + "static/media/stack-of-coins.645ecdc7.png";